export default {
  phone: "phone",
  email: "email",
  ad: "ad",
  transferLogin: "transferLogin",
};
